import { motion } from 'framer-motion'
import { BorderBeam, GradientText } from '@/components/gradient/index.jsx'
import { Button } from '@/components/ui/button.jsx'

export const NewVersionMessage = () => {
    return (
        <motion.div
            initial={{ opacity: 0, bottom: "-100px" }}
            animate={{ opacity: 1, bottom: 0 }}
            transition={{ type: "tween", duration: 0.5 }}
            className="fixed bottom-0 right-0 m-4 p-4 bg-background rounded-lg z-40 border flex flex-col justify-center items-center gap-2"
        >
            <BorderBeam />
            <GradientText>
                New version available!
            </GradientText>
            <Button  className="w-full" onClick={() => window.location.reload()}>
                Click here to refresh the page
            </Button>

        </motion.div>
    )
}